import script from "./signInSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./signInSurvey.vue?vue&type=script&setup=true&lang=js"

import "./signInSurvey.vue?vue&type=style&index=0&id=0bbc867e&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbc867e"]])

export default __exports__